module.exports = __webpack_public_path__ + "static/img/home_title_business@2x.5d49913.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images2/home_title_business@2x.png
// module id = sX9u
// module chunks = 1